import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { QueueCountersAPI } from '@api/queueCountersAPI'

import { Option } from '@models/option'

import { AsyncSelectField, AsyncSelectFieldProps } from '@components/Form/AsyncSelect/AsyncSelectField'

import { CheckInFormShape } from '../QueueCheckinCounterForm'
import { ID } from '@models/base'

type Props<IsMulti extends boolean> = Omit<AsyncSelectFieldProps<IsMulti>, 'onSearch'> & {
  defaultValue?: Option
}

const CounterListSelectField = <IsMutli extends boolean = false>({ defaultValue, ...props }: Props<IsMutli>) => {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext<CheckInFormShape>()

  useEffect(() => {
    setFieldValue(props.name, null)
    // eslint-disable-next-line
  }, [values.queue_id.value])

  const searchDebounce = async (keyword: string): Promise<Array<Option>> => {
    const counters = await QueueCountersAPI.getOptionsForCheckIn({ queue_id: values.queue_id.value as ID }).then(
      (r) => r.data?.nodes
    )

    return counters!.map(
      (counter) =>
        new Option({
          label: counter.name!,
          value: counter.id!,
          data: {
            id: counter.id,
          },
        })
    )
  }

  return (
    <AsyncSelectField
      {...props}
      key={values.queue_id.value}
      isSearchable={false}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'queue.counter_not_found' })}
      defaultValue={defaultValue}
    />
  )
}

export { CounterListSelectField }
